import { components } from 'src/mock/generated-schema';

export const hasPublishedEvent = (eventsList: components['schemas']['WorkflowEvent'][]) : boolean =>
  (eventsList?.length
    ? Boolean(eventsList.find((obj) => obj?.modelEventType?.id === 'wevent:PublishedOnline'))
    : false);
